export interface Partner {
  id: string;
  name: string;
  logo: string;
  description: string;
  website?: string;
}

export const constructionPartners: Partner[] = [
  {
    id: '1',
    name: 'Cyrela',
    logo: '/partners/cyrela-logo.png',
    description: 'Uma das maiores incorporadoras do Brasil',
    website: 'https://www.cyrela.com.br/',
  },
  {
    id: '2',
    name: 'Eztec',
    logo: '/partners/logo eztec.png',
    description: 'Excelência em incorporação imobiliária',
    website: 'https://www.eztec.com.br/',
  },
  {
    id: '3',
    name: 'Even',
    logo: '/partners/Logo-even.png',
    description: 'Empreendimentos de médio e alto padrão',
    website: 'https://www.even.com.br/',
  },
  {
    id: '4',
    name: 'Lavvi',
    logo: '/partners/LAVVI LOGO.png',
    description: 'Inovação e qualidade',
    website: 'https://www.lavvi.com.br/',
  },
  {
    id: '5',
    name: 'Nortis',
    logo: '/partners/nortis logo.png',
    description: 'Desenvolvimento sustentável',
    website: 'https://www.nortisinc.com.br/',
  },
  {
    id: '6',
    name: 'Mitre',
    logo: '/partners/Mitre logo.jpg',
    description: 'Empreendimentos de alto padrão',
    website: 'https://www.mitrerealty.com.br/',
  },
  {
    id: '7',
    name: 'Teixeira Duarte',
    logo: '/partners/TEIXEIRA DUARTE LOGO.jpg',
    description: 'Tradição e excelência na construção',
    website: 'https://www.teixeiraduarteconstrucao.com.br/',
  },
  {
    id: '8',
    name: 'One Innovation',
    logo: '/partners/One innovation - LOGO.jpg',
    description: 'Inovação em cada projeto',
    website: 'https://oneinnovation.com.br/',
  },
  {
    id: '9',
    name: 'Tegra',
    logo: '/partners/tegra - logo.jpg',
    description: 'Incorporadora com DNA inovador',
    website: 'https://www.tegraincorporadora.com.br/sp',
  },
  {
    id: '10',
    name: 'Setin',
    logo: '/partners/Setin - logo.jpg',
    description: 'Qualidade e pontualidade',
    website: 'https://www.setin.com.br/',
  },
  {
    id: '11',
    name: 'Gamaro',
    logo: '/partners/Logo Gamaro.png',
    description: 'Construindo sonhos',
    website: 'https://gamaro.com.br/',
  },
  {
    id: '12',
    name: 'Kallas',
    logo: '/partners/logo-kallas.png',
    description: 'Empreendimentos exclusivos',
    website: 'https://kazzas.com.br/',
  },
  {
    id: '13',
    name: 'Yuny',
    logo: '/partners/logo_yuny-incorporadora.png',
    description: 'Incorporadora moderna',
    website: 'https://www.yuny.com.br/',
  },
  {
    id: '14',
    name: 'Ryazbek',
    logo: '/partners/ryazbek_logo.jpg',
    description: 'Tradição e modernidade',
    website: 'https://ryazbek.com.br/',
  },
  {
    id: '15',
    name: 'Trisul',
    logo: '/partners/LOGO TRISUL.jpg',
    description: 'Compromisso com qualidade e prazo',
    website: 'https://trisul-sa.com.br/',
  },
  {
    id: '16',
    name: 'Exto',
    logo: '/partners/LOGO-EXTO.png',
    description: 'Incorporação de alta qualidade',
    website: 'https://www.exto.com.br/',
  },
  {
    id: '17',
    name: 'Cury',
    logo: '/partners/LOGO CURY.png',
    description: 'Líder em incorporação',
    website: 'https://cury.net/',
  },
  {
    id: '18',
    name: 'Plano e Plano',
    logo: '/partners/Plano&Plano logo.png',
    description: 'Empreendimentos planejados',
    website: 'https://www.planoeplano.com.br/',
  },
  {
    id: '19',
    name: 'Ditolvo',
    logo: '/partners/ditolvo.jpg',
    description: 'Qualidade construtiva',
    website: 'https://ditolvo.com.br/',
  },
  {
    id: '20',
    name: 'Tarjab',
    logo: 'https://via.placeholder.com/200x100/3D6B1F/FFFFFF?text=TARJAB',
    description: 'Incorporadora de confiança',
    website: 'https://www.tarjab.com.br/',
  },
];
